/** @typedef {{description: string; illustration: string; title: string}} Props */

import { translate } from '../../../Internationalization';
import images from '../../../../config/local/images';
import React from 'react';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function WidgetHeader(props) {
	return (
		<section className="relative my-6">
			<section>
				<h2 className="hl-ms-4 mb-6">{props.title}</h2>
				<p className="mb-6 w-3/4">{props.description}</p>
			</section>

			<figure className="absolute right-0 -top-2/3">
				<img
					alt={translate('homeowner.pages.checklists.alt')}
					className="illustration"
					src={
						props.illustration ?? images.homeowners.documents.header
					}
				/>
			</figure>
		</section>
	);
}

export default React.memo(WidgetHeader);
